<template lang="pug">
  el-menu-item(
    index='/smart_cards'
  )
    .img-wrapper
      img(src="@src/assets/sidebar/smart-card-icon.svg")
    router-link.sub-menu-link(to="/smart_cards")
      span  {{ $t('sidebar.smart_cards') }}
</template>

<script>
import { general } from "@src/services/dynamicViews/general";
import { dynamicViewsConstants } from "@src/constants";
import { mapState } from "vuex";


export default {
  name: "SmartCardsItem",
  mixins: [general],

  computed: {
    ...mapState("auth", ["user"]),
  },

  data() {
    return {
      dynamicViewsConstants
    }
  }
}
</script>
